/**
 * @generated SignedSource<<001e287fb0beb968a5b674fbf3585768>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InterviewCompletionSection_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "individualSummary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "formField",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "closingMessage",
              "storageKey": null
            }
          ],
          "type": "FormFieldOralInterview",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswerOralInterview",
  "abstractKey": null
};

node.hash = "756cf5a482e9e4585fc6048ea4d89c9d";

module.exports = node;
